import { LoadingState } from '@lcs/shared/api';
import { createFeatureSelector, on } from '@ngrx/store';
import { OrderingDirections, OrderingOption } from 'generated/graphql-types';
import { RegisterState } from 'src/app/common-components/register/models/register-state';
import {
   RegisterAdapter,
   createRegisterAdapter,
} from 'src/app/common-components/register/models/register-state.adapter';
import { MailboxFilterOptions } from '../models/mailbox-filter-option';
import { MailboxRegisterOptions } from '../models/mailbox-register-options';
import { MailboxRegisterListItem } from '../models/mailbox-register-results.model';
import * as mailboxRegisterActions from './mailbox-register.actions';
import { mailboxRegisterAdapterActions } from './mailbox-register.actions';

export const mailboxRegisterFeatureKey = 'mailboxRegister';
export interface MailboxRegisterState
   extends RegisterState<MailboxRegisterListItem, MailboxRegisterOptions, OrderingOption> {
   filters: MailboxFilterOptions[];
}

const adapter: RegisterAdapter<MailboxRegisterListItem, MailboxRegisterOptions, OrderingOption> = createRegisterAdapter<
   MailboxRegisterListItem,
   MailboxRegisterOptions,
   OrderingOption
>({
   selectId: (mailboxRegisterItem) => {
      return mailboxRegisterItem.mailboxId ?? 0;
   },
});

const initialState: MailboxRegisterState = {
   ...adapter.getInitialState(),
   filters: [],
   orderingOptions: [{ direction: OrderingDirections.Asc, field: 'extension.number' }],
};

export const mailboxRegisterReducer = adapter.createReducer(
   mailboxRegisterActions.mailboxRegisterAdapterActions,
   initialState,
   on(mailboxRegisterActions.mailboxRegisterAdapterActions.pageEnter, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(mailboxRegisterActions.mailboxRegisterAdapterActions.loadSuccess, (state, action) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
         endCursor: action.endCursor,
         hasNextPage: action.hasNextPage,
         mailbox: action.items,
         totalCount: action.totalCount,
      };
   }),
   on(mailboxRegisterActions.mailboxRegisterInitialFilter, (state, action) => {
      return {
         ...state,
         callState: LoadingState.Loading,
         filters: action.filters,
      };
   }),
   on(mailboxRegisterAdapterActions.quickFilterChanged, (state, action) => {
      return {
         ...state,
         callState: LoadingState.Loading,
         quickFilters: {
            ...state.quickFilters,
            ...action.quickFilters,
         },
      };
   }),
   on(mailboxRegisterActions.mailboxRegisterAdapterActions.orderingOptionsChanged, (state, action) => {
      return {
         ...state,
         callState: LoadingState.Loading,
         orderingOptions: state.orderingOptions
            ? [
                 ...state.orderingOptions
                    .filter((option) => !action.orderingOptions.some((newOption) => newOption.field === option.field))
                    .filter((option) => option.direction !== OrderingDirections.NotSet),
                 ...action.orderingOptions,
              ]
            : action.orderingOptions,
      };
   })
);
export const mailboxRegisterSelector = createFeatureSelector<MailboxRegisterState>(mailboxRegisterFeatureKey);
export const selectors = adapter.getSelectors(mailboxRegisterSelector);
export const {
   selectAll,
   selectCallState,
   selectTotalCount,
   selectEndCursor,
   selectQuickFilters,
   selectOrderingOptions,
} = adapter.getSelectors(mailboxRegisterSelector);
